var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _rect, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _path, _polygon37, _polygon38, _polygon39, _polygon40, _rect2, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _polygon62, _polygon63, _polygon64, _polygon65, _polygon66, _polygon67, _polygon68, _polygon69, _polygon70, _metadata;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyepaxSymbol15X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #eb523c;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #a2d0ea;\r\n      }\r\n\r\n      .st2 {\r\n        fill: #f6ea81;\r\n      }\r\n\r\n      .st3 {\r\n        fill: #994439;\r\n      }\r\n\r\n      .st4 {\r\n        fill: #f0cd3b;\r\n      }\r\n\r\n      .st5 {\r\n        fill: #a5dcee;\r\n      }\r\n\r\n      .st6 {\r\n        fill: #ebc01d;\r\n      }\r\n\r\n      .st7 {\r\n        fill: #63a8d5;\r\n      }\r\n\r\n      .st8 {\r\n        fill: #c5da5e;\r\n      }\r\n\r\n      .st9 {\r\n        fill: #b7ca3c;\r\n      }\r\n\r\n      .st10 {\r\n        fill: #9ebb3c;\r\n      }\r\n\r\n      .st11 {\r\n        fill: #cab041;\r\n      }\r\n\r\n      .st12 {\r\n        fill: #3f80a1;\r\n      }\r\n\r\n      .st13 {\r\n        fill: #ae4a37;\r\n      }\r\n\r\n      .st14 {\r\n        fill: #cbdd6f;\r\n      }\r\n\r\n      .st15 {\r\n        fill: #526a31;\r\n      }\r\n\r\n      .st16 {\r\n        fill: #647e37;\r\n      }\r\n\r\n      .st17 {\r\n        fill: #c4463a;\r\n      }\r\n\r\n      .st18 {\r\n        fill: #d6644d;\r\n      }\r\n\r\n      .st19 {\r\n        fill: #b28b2e;\r\n      }\r\n\r\n      .st20 {\r\n        fill: #89ac4d;\r\n      }\r\n\r\n      .st21 {\r\n        fill: #85a13d;\r\n      }\r\n\r\n      .st22 {\r\n        fill: #f7e07e;\r\n      }\r\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "7.4 14.4 13.1 14.4 10.3 11.5 7.4 14.4"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "10.3 11.5 13.1 8.6 16 11.5 13.1 14.4 10.3 11.5"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "16 11.5 16 5.8 13.1 8.6 16 11.5"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "16 11.5 18.8 8.7 18.8 2.9 16 5.8 16 11.5"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "18.8 2.9 24.6 8.7 18.8 14.4 18.8 2.9"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "18.8 14.4 24.6 14.4 21.7 11.5 18.8 14.4"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "24.5 14.4 30.3 14.4 30.3 8.7 24.5 14.4"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "18.8 2.9 24.6 8.7 30.3 2.9 18.8 2.9"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "30.3 2.9 36 8.7 41.7 2.9 30.3 2.9"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "30.3 8.7 36 14.4 30.3 14.4 30.3 8.7"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "33.1 5.8 36 8.7 33.1 11.5 33.1 5.8"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "33.1 5.8 33.1 11.5 30.3 8.7 30.3 2.9 33.1 5.8"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "30.3 2.9 30.3 8.7 27.4 11.6 27.4 5.8 30.3 2.9"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "21.7 11.5 24.6 14.4 27.4 11.5 24.6 8.6 21.7 11.5"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "36 14.4 38.8 11.5 41.7 14.4 36 14.4"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "41.7 14.4 41.7 2.9 36 8.7 41.7 14.4"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "41.7 2.9 47.4 8.7 41.7 14.4 41.7 2.9"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "41.7 14.4 47.4 8.7 53.2 14.4 41.7 14.4"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "38 14.4 53.2 14.4 45.8 22.2 38 14.4"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "36 8.7 33.1 11.5 36 14.4 38.8 11.5 36 8.7"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "34.1 18.3 38.1 14.4 41.9 18.3 34.1 18.3"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "30.3 22.2 34.2 18.3 38 18.3 34.1 22.2 30.3 22.2"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "34.1 22.2 38 22.2 38 18.2 34.1 22.2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st21",
    x: 38,
    y: 18.3,
    width: 3.9,
    height: 3.9
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "41.9 22.2 41.9 18.2 45.8 22.2 41.9 22.2"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "18.6 18.3 22.5 14.4 26.4 18.3 18.6 18.3"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "22.5 18.3 22.5 22.2 26.3 22.2 22.5 18.3"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "22.5 18.3 18.6 18.3 18.6 22.2 22.5 22.2 22.5 18.3"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "18.6 18.3 14.7 22.2 18.6 22.2 18.6 18.3"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "14.7 22.2 22.5 22.2 22.5 30 14.7 22.2"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "22.5 22.2 30.3 22.2 22.5 30 22.5 22.2"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "26.4 18.3 22.5 18.3 26.3 22.2 30.3 22.2 26.4 18.3"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "30.3 22.2 38.1 30 38.1 22.2 30.3 22.2"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "38 30 38 22.2 45.8 22.2 38 30"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "26.4 26 30.3 22.2 34.1 26 26.4 26"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "30.3 26 34.1 30 38.1 30 34.1 26 30.3 26"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "30.3 26 30.3 30 34.2 30 30.3 26"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "30.3 26 30.3 30 26.3 30 30.3 26"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "30.3 26 26.4 26 26.4 30 30.3 26"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M26.4,26v3.9s-4,0-3.9,0c0,0,3.9-3.9,3.9-3.9Z"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "30.3 37.8 30.3 30 38.1 30 30.3 37.8"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "22.5 30 30.3 30 30.3 37.8 22.5 30"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "22.5 37.8 22.4 45.6 30.3 37.8 22.5 37.8"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "18.6 37.8 22.5 37.8 22.5 33.9 18.6 37.8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st21",
    x: 18.6,
    y: 37.8,
    width: 3.9,
    height: 3.9
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "18.5 41.7 22.4 45.6 22.5 41.7 18.5 41.7"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "18.6 41.7 18.6 33.9 14.7 37.8 18.6 41.7"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "22.4 30 22.4 37.8 30.3 37.8 22.4 30"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "18.6 33.9 18.6 37.8 22.5 33.9 22.5 30 18.6 33.9"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "22.5 45.6 6.9 45.6 14.7 37.8 22.5 45.6"
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "14.7 22.2 7.4 14.4 22.5 14.4 14.7 22.2"
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.8 45.6 12.6 45.6 9.7 48.5 6.8 45.6"
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "12.5 45.6 18.3 45.6 18.3 51.3 12.5 45.6"
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "9.7 48.5 12.5 45.6 15.5 48.5 12.6 51.3 9.7 48.5"
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "12.6 51.3 15.5 48.5 15.5 54.2 12.6 51.3"
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "15.5 54.2 18.3 57.1 18.3 51.3 15.5 48.5 15.5 54.2"
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "18.3 45.6 24 45.6 21.2 48.5 18.3 45.6"
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "18.3 45.6 24 51.3 18.3 57.1 18.3 45.6"
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "18.3 57.1 24 51.3 29.7 57.1 18.3 57.1"
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "29.7 51.3 29.7 45.6 24 45.6 29.7 51.3"
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "29.7 45.6 29.7 51.3 35.4 45.6 29.7 45.6"
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "29.7 57.1 29.7 51.3 32.6 48.5 32.6 54.2 29.7 57.1"
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "32.6 54.2 35.4 51.3 32.6 48.5 32.6 54.2"
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "41.2 57.1 41.2 45.6 35.4 51.3 41.2 57.1"
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "41.2 45.6 41.2 57.1 46.9 51.3 41.2 45.6"
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "41.2 45.6 46.9 51.3 52.6 45.6 41.2 45.6"
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "37.5 45.6 32.3 40.4 46.9 40.4 52.6 45.6 37.5 45.6"
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "35.4 51.3 38.3 48.5 35.4 45.6 32.6 48.5 35.4 51.3"
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "35.4 45.6 38.3 48.5 41.2 45.6 35.4 45.6"
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "26.8 54.2 26.8 48.4 29.7 51.3 29.7 57.1 26.8 54.2"
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "24 51.3 26.9 48.4 26.9 54.2 24 51.3"
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "21.2 48.5 24 45.6 26.9 48.4 24 51.3 21.2 48.5"
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "13.1 14.4 18.8 14.4 18.8 8.7 13.1 14.4"
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "29.7 57.1 35.4 51.3 41.2 57.1 29.7 57.1"
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "27.4 5.8 24.6 8.7 27.4 11.5 27.4 5.8"
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "http://ns.adobe.com/SaveForWeb/1.0/"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    x: -315.08,
    y: 227.76,
    width: 46.33,
    height: 54.1,
    bottomLeftOrigin: "true"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyepaxSymbol15X);
export default __webpack_public_path__ + "static/media/Eyepax Symbol 1.5x.c635ac70a96ec973ac632a83c19babfd.svg";
export { ForwardRef as ReactComponent };